module.exports = {
  textField : {
    fontFamily: 'Cochin',
  }
}
